"use client";
import { cn } from "@/lib/utils";
import Image from "next/image";
import React from "react";

interface WhatMakesCourseDifferentCardProps {
  cardImage: string;
  cardImageAlt?: string;
  cardTitle: string;
  cardDescription: string;
  cardTitleColor: string;
  cardDescriptionColor: string;
  cardColor: string;
  onClick?: () => void;
}
const WhatMakesCourseDifferentCard = ({
  cardImage,
  cardImageAlt,
  cardTitle,
  cardDescription,
  cardTitleColor,
  cardDescriptionColor,
  cardColor,
  onClick,
}: WhatMakesCourseDifferentCardProps) => {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onClick?.();
  };

  return (
    <div
      className={cn(
        "flex flex-col items-center justify-start w-full min-w-0 cursor-pointer",
        "xs:gap-3 xs:p-[18px] xs:border xs:border-gray-3 xs:rounded-lg",
        "sm:p-[18px]",

        "h-[292px]",
        " md:h-[328px]",
        "lg:h-[330px]",
        "xl:h-[450px]",
      )}
      style={{ backgroundColor: cardColor }}
      onClick={handleClick}
    >
      {cardImage && (
        <Image
          src={cardImage}
          alt={cardImageAlt || "Card image"}
          className={cn(
            "w-full object-cover rounded-[10px]",
            "xs:h-[126px]",
            "sm:h-[126px]",
            "md:h-[144px]",
            "lg:h-[144px]",
            "xl:h-[194px]",
          )}
          width={400}
          height={200}
          style={{ maxWidth: "100%" }}
        />
      )}
      <div className="flex flex-col gap-2 w-full">
        <div
          className={cn(
            "break-words",
            "xs:text-heading-8-semibold xs:line-clamp-1",
            "sm:text-heading-7-semibold",
            "md:text-heading-7-semibold",
            "lg:text-heading-7-semibold",
            "xl:text-heading-6-semibold",
            "type-h6",
          )}
          style={{ color: cardTitleColor }}
        >
          {cardTitle}
        </div>
        <div
          className={cn(
            "break-words",
            "xs:text-heading-9-regular xs:line-clamp-3",
            "sm:text-heading-9-regular sm:line-clamp-3",
            "md:text-heading-8-regular",
            "lg:text-heading-8-regular",
            "xl:text-heading-6-regular",
            "type-body-sm",
          )}
          style={{ color: cardDescriptionColor }}
        >
          {cardDescription}
        </div>
      </div>
    </div>
  );
};

export default WhatMakesCourseDifferentCard;
